<template>
    <div class="row">
        <div class="col-12 text-center">
            <h3>TUS ASIENTOS</h3>
        </div>
        <div class="col-12" v-if="asientos.length == 0">
            <p>Seleccione los asientos para continuar</p>
        </div>
        <template v-else>
            <template v-for="(asiento, index) in asientos">
                <div class="col-12 bg-secondary mb-2" :key="index" v-if="asiento.asiento">
                    {{ ++index }}. {{ asiento.asiento.zona_nombre }} <br>
                    <span v-if="asiento.asiento.fila && asiento.asiento.asiento">
                        Fila: {{ asiento.asiento.fila }} - Butaca: {{ asiento.asiento.asiento }}
                    </span>
                    <span v-else>Sin numerar</span>
                </div>
            </template>
            <div class="col-12" v-if="configuracion_valida">
                <Button class="btn-block" @click.prevent="continuar">CONTINUAR COMPRA</Button>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        props: ['asientos', 'configuracion_valida'],
        methods: {
            continuar() {
                this.$emit('continuar');
            }
        },
    }
</script>
